import { postConstants } from '../constants';
import { postService } from '../../services';

export const postActions = {
  postsList,
  addPost,
  getPost,
  updatePost
}

/*
ACTION: Posts List
*/
function postsList(addToast, pageID, perPage) {
  return dispatch => {
    dispatch(request());
    return postService.postsList(pageID, perPage)
      .then(
        response => {
          dispatch(success(response.data.body.posts, response.data.body.data.total));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: postConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: postConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: postConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add Post
*/
function addPost(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return postService.addPost(formData)
      .then(
        response => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: postConstants.ADD_REQUEST } }
  function success(status) { return { type: postConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: postConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get Post By ID
*/
function getPost(addToast, postID) {
  return dispatch => {
    dispatch(request());
    return postService.getPost(postID)
      .then(
        response => {
          dispatch(success(response.data.body));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: postConstants.GET_REQUEST } }
  function success(item) { return { type: postConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: postConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Post
*/
function updatePost(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return postService.updatePost(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: postConstants.UPDATE_REQUEST } }
  function success(status) { return { type: postConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: postConstants.UPDATE_FAILURE, error } }
}